import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { recaptchaService } from '../../domain/services';
import application from '../../../config/app/config';
import { useAppState } from '../../hooks/zustandHooks';

interface IProps {
  size: typeof application.recaptcha.SIZE;
  sitekey: typeof application.recaptcha.SITE_KEY;
}

const Recaptcha = forwardRef<Omit<ReCAPTCHA, 'sitekey'>, IProps>((props, ref) => {
  const useValidationToken = useAppState(state => state.appState.useValidationToken);
  const isEnabled = !useValidationToken;

  const updateValidationToken = (validationToken: string | null) => {
    if (!validationToken) recaptchaService.reset();
  };
  if (!isEnabled) return null;

  return (
    <div aria-hidden="true" data-testid="recaptcha-container">
      <ReCAPTCHA
        {...props}
        ref={ref}
        onChange={updateValidationToken}
        onErrored={() => {
          recaptchaService.reset();
        }}
      />
    </div>
  );
});

export { Recaptcha };
export default Recaptcha;
